import { NgModule } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../app/components/home/home.component';
import { SignupComponent } from './components/signup/signup.component';
import { AWelcomeComponent } from './components/signup/a-welcome/a-welcome.component';
import { BStartComponent } from './components/signup/b-start/b-start.component';
import { CNotSureComponent } from './components/signup/c-not-sure/c-not-sure.component';
import { CStartMAHComponent } from './components/signup/c-start-mah/c-start-mah.component';
import { CStartISPComponent } from './components/signup/c-start-isp/c-start-isp.component';
import { DCompanyNameComponent } from './components/signup/d-company-name/d-company-name.component';
import { ECompanyInfoComponent } from './components/signup/e-company-info/e-company-info.component';
import { ECompanyInfoISPComponent } from './components/signup/e-company-info-isp/e-company-info-isp.component';
import { FCompanyInfoISPComponent } from './components/signup/f-company-info-isp/f-company-info-isp.component';
import { FCompanyInfoMahComponent } from './components/signup/f-company-info-mah/f-company-info-mah.component';
import { FCompanyMACTransComponent } from './components/signup/f-company-mactrans/f-company-mactrans.component';
import { GCompnayFeesComponent } from './components/signup/g-compnay-fees/g-compnay-fees.component';
import { HUserAccessComponent } from './components/signup/h-user-access/h-user-access.component';
import { IUserAccessContactComponent } from './components/signup/i-user-access-contact/i-user-access-contact.component';
import { JUserAccessUserInfoComponent } from './components/signup/j-user-access-user-info/j-user-access-user-info.component';
import { KReviewComponent } from './components/signup/k-review/k-review.component';
import { LReviewUserComponent } from './components/signup/l-review-user/l-review-user.component';
import { MHowComponent } from './components/signup/m-how/m-how.component';
import { NTACComponent } from './components/signup/n-tac/n-tac.component';
import { OCERTComponent } from './components/signup/o-cert/o-cert.component';
import { PDisclosureAndAuthComponent } from './components/signup/p-disclosure-and-auth/p-disclosure-and-auth.component';
import { QCreatePaymentComponent } from './components/signup/q-create-payment/q-create-payment.component';
import { RAchCardPaymentComponent } from './components/signup/r-ach-card-payment/r-ach-card-payment.component';
import { SAllDoneErrorComponent } from './components/signup/s-all-done-error/s-all-done-error.component';
import { SAllDoneGoodComponent } from './components/signup/s-all-done-good/s-all-done-good.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { dashboardGuard } from './guards/dashboard.guard';
import { TermsandconditionsComponent } from './components/termsandconditions/termsandconditions.component';
import { VeteransComponent } from './components/veterans/veterans.component';
import { WomenDriversComponent } from './components/women-drivers/women-drivers.component';
import { termsandconditionsGuard } from './guards/termsandconditions.guard';
import { AccessdeniedComponent } from './components/accessdenied/accessdenied.component';
import { ContactComponent } from './components/contact/contact.component';
import { FAQsComponent } from './components/faqs/faqs.component';

import { InvoiceComponent } from './components/invoice/invoice.component';
import { By } from '@angular/platform-browser';
import { ByauthcodeComponent } from './components/byauthcode/byauthcode.component';
import { WSAPIComponent } from './components/WSToken/wsapi/wsapi.component';
import { WSTokenComponent } from './components/WSToken/wstoken/wstoken.component';
import { BillingReportsComponent } from './components/billing-reports/billing-reports.component';
import { BillingSummaryComponent } from './components/billing-reports/billing-summary/billing-summary.component';
import { GenericStatementComponent } from './components/billing-reports/generic-statement/generic-statement.component';
import { SinglePaperInvoiceComponent } from './components/billing-reports/single-paper-invoice/single-paper-invoice.component';
import { NewsComponent } from './components/news/news.component';
import { DriversComponent } from './components/drivers/drivers.component';
import { RequestrecordsComponent } from './components/requestrecords/requestrecords.component';
import { ProbationOrderSuccessComponent } from './components/probation-order-success/probation-order-success.component';
import { ApplicationexceptionComponent } from './components/applicationexception/applicationexception.component';
import { AuditAcknowledgementComponent } from './components/audit/audit-acknowledgement/audit-acknowledgement.component';
import { AuditDashboardComponent } from './components/audit/audit-dashboard/audit-dashboard.component';

import { DriverComponent } from './components/driver/driver.component';
import { StartComponent } from './components/driver/a-start/start.component';
import { DisclaimersComponent } from './components/driver/b-disclaimers/disclaimers.component';
import { ContactInfoComponent } from './components/driver/c-contact-info/contact-info.component';
import { EmailComponent } from './components/driver/d-email/email.component';
import { AddressComponent } from './components/driver/e-address/address.component';
import { LicenseComponent } from './components/driver/f-license/license.component';
import { ReviewComponent } from './components/driver/g-review/review.component';
import { BillingAddressComponent } from './components/driver/h-billing-address/billing-address.component';
import { IdQuizComponent } from './components/driver/i-id-quiz/id-quiz.component';
import { OrderSuccessComponent } from './components/driver/j-order-success/order-success.component';
import { OrderFailComponent } from './components/driver/k-order-fail/order-fail.component';
import { IdVerifyFailComponent } from './components/driver/l-id-verify-fail/id-verify-fail.component';
import { CustomerSupportInfoComponent } from './components/customer-support-info/customer-support-info.component';
import { UserAccountAdminComponent } from './components/user-account-admin/user-account-admin.component';
import { EditUserComponent } from './components/UserAccountAdmin/edit-user/edit-user.component';
import { generalGuard } from './guards/general.guard';
import { WrongRouteComponent } from './components/wrong-route/wrong-route.component';
import { SessionTimerService } from './services/session-timer.service';
import { ParamMap } from '@angular/router';
import { MangagePaymentMethodsComponent } from './components/mangage-payment-methods/mangage-payment-methods.component';
import { DriverDashboardComponent } from './components/driver-dashboard/driver-dashboard.component';
import { driverDashboardGuard } from './guards/driver-dashboard.guard';
import { DriverMonitorSettingsComponent } from './components/driver-monitor-settings/driver-monitor-settings.component';
import { SigninComponent } from './components/signin/signin.component';
import { byAuthCodeGuard } from './guards/by-auth-code.guard';
import { AuthenticationService } from './services/authentication.service';
import { environment } from 'src/environments/environment';
import { ByAuthCodeRedirectComponent } from './components/by-auth-code-redirect/by-auth-code-redirect.component';
import { start } from '@popperjs/core';
import { GeneralService } from './services/general.service';
import { MvrByStateComponent } from './components/mvr-by-state/mvr-by-state.component';
import { SubscribedComponent } from './components/driver/subscribed/subscribed.component';

const routes: Routes = [
     { path: 'home', component: HomeComponent, data: { languages: ["EN", "ES", "FR"] } },
     {
          path: 'signup', component: SignupComponent, data: { languages: ["EN","ES","FR"] } , 
          children: [
               {
                    path: 'welcome', component: AWelcomeComponent
               },
               {
                    path: '1', component: BStartComponent
               },
               {
                    path: '2', component: CStartMAHComponent
               },
               {
                    path: '3', component: CStartISPComponent
               },
               {
                    path: '4', component: CNotSureComponent
               },
               {
                    path: '5', component: DCompanyNameComponent
               },
               {
                    path: '6', component: ECompanyInfoComponent
               },
               {
                    path: '7', component: ECompanyInfoISPComponent
               },
               {
                    path: '9', component: FCompanyInfoISPComponent
               },
               {
                    path: '8', component: FCompanyInfoMahComponent
               },
               {
                    path: '10', component: FCompanyMACTransComponent
               },
               {
                    path: '11', component: GCompnayFeesComponent
               },
               {
                    path: '12', component: HUserAccessComponent
               },
               {
                    path: '13', component: IUserAccessContactComponent
               },
               {
                    path: '14', component: JUserAccessUserInfoComponent
               },
               {
                    path: '15', component: KReviewComponent
               },
               {
                    path: '16', component: LReviewUserComponent
               },
               {
                    path: '17', component: MHowComponent
               },
               {
                    path: '18', component: NTACComponent
               },
               {
                    path: '19', component: OCERTComponent
               },
               {
                    path: '20', component: PDisclosureAndAuthComponent
               },
               {
                    path: '21', component: QCreatePaymentComponent
               },
               {
                    path: '22', component: RAchCardPaymentComponent
               },
               {
                    path: '23', component: SAllDoneErrorComponent
               },
               {
                    path: '24', component: SAllDoneGoodComponent
               },
               {
                    path: '', redirectTo: '/welcome', pathMatch: 'full'
               },
          ]
     },
     { path: 'dashboard', component: DashboardComponent, canActivate: [dashboardGuard], data: { restricted: true, languages: ["EN","ES","FR"] } },
     { path: 'termsandconditions', component: TermsandconditionsComponent, canActivate: [termsandconditionsGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'veterans', component: VeteransComponent, data: { languages: ["EN", "ES", "FR"] } },
     { path: 'women-drivers', component: WomenDriversComponent, data: { languages: ["EN"] } },
     { path: 'drivers', component: DriversComponent, data: { languages: ["EN","ES", "FR"] } },
     { path: 'accessDenied', component: AccessdeniedComponent, data: { languages: ["EN"]} },
     { path: 'customerSupport', component: ContactComponent, data: {languages: ["EN","ES","FR"] } },
     { path: 'FAQ', component: FAQsComponent, data: {languages: ["EN","ES","FR"] } },
     { path: 'invoice', component: InvoiceComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'byAuthCode/:authcode', component: ByauthcodeComponent, canActivate: [byAuthCodeGuard], data: { restricted: true,languages: ["EN"] }  },
     { path: 'requestRecords', component: RequestrecordsComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN","ES","FR"] }  },
     { path: 'probationOrderSuccess', component: ProbationOrderSuccessComponent, data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'applicationException', component: ApplicationexceptionComponent, data: { languages: ["EN","ES","FR"] } },
     { path: 'auditAcknowledgement', component: AuditAcknowledgementComponent, data: { restricted: true, languages: ["EN","ES","FR"] } },
     { path: 'signin', component: SigninComponent, data: { languages: ["EN", "ES", "FR"] } },
     { path: 'wsAPI', component: WSAPIComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'wsToken', component: WSTokenComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'billingReports', component: BillingReportsComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'billing-summary', component: BillingSummaryComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'generic-statement', component: GenericStatementComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'single-paper-invoice', component: SinglePaperInvoiceComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'news', component: NewsComponent, data: { restricted: true, languages: ["EN","ES","FR"]  } },
     { path: 'auditDashboard', component: AuditDashboardComponent, data: { restricted: true, languages: ["EN", "ES", "FR"] }  },
     { path: 'customerSupportInfo', component: CustomerSupportInfoComponent, data: {languages: ["EN","ES","FR"] } },
     {
          path: 'driver', component: DriverComponent, data: { languages: ["EN","ES","FR"] },
          children: [
               { path: '1', component: StartComponent },
               { path: '1/subscribe', component: StartComponent },
               { path: '2', component: EmailComponent },
               { path: '2/subscribe', component: EmailComponent },
               { path: '3', component: DisclaimersComponent },
               { path: '3/subscribe', component: DisclaimersComponent },
               { path: '4', component: ContactInfoComponent },
               { path: '4/subscribe', component: ContactInfoComponent },
               { path: '5', component: AddressComponent },
               { path: '5/subscribe', component: AddressComponent },
               { path: '6', component: LicenseComponent },
               { path: '6/subscribe', component: LicenseComponent },
               { path: '7', component: ReviewComponent },
               { path: '7/subscribe', component: ReviewComponent },
               { path: '8', component: BillingAddressComponent },
               { path: '9', component: IdQuizComponent },
               { path: '9/subscribe', component: IdQuizComponent },
               { path: '10', component: OrderSuccessComponent },
               { path: '11', component: OrderFailComponent },
               { path: '12', component: IdVerifyFailComponent },
               { path: 'subscribed', component: SubscribedComponent },
               { path: '', redirectTo: '/1', pathMatch: 'full' }
          ]
     },
     { path: 'MvrByState', component: MvrByStateComponent, data: { languages: ["EN"] }},
     { path: 'userAccountAdmin', component: UserAccountAdminComponent, canActivate: [generalGuard] , data: { restricted: true,languages: ["EN","ES","FR"] }},
     { path: 'editAccountAdmin',  component: EditUserComponent, canActivate: [generalGuard], data: { restricted: true, languages: ["EN", "ES", "FR"] } },
     { path: 'payment', component: MangagePaymentMethodsComponent, canActivate: [generalGuard] , data: { restricted: true,languages: ["EN","ES","FR"] }},
     { path: 'driverDashboard', component: DriverDashboardComponent, canActivate: [driverDashboardGuard], data: { languages: ["EN", "ES", "FR"] } },
     { path: 'monitoring', component: DriverMonitorSettingsComponent, canActivate: [driverDashboardGuard], data: { languages: ["EN", "ES", "FR"] } },
     { path: 'Account/DriverRecord/ByAuthCode', component: ByAuthCodeRedirectComponent, data: { languages: ["EN", "ES", "FR"] } },
     { path: '', redirectTo: '/home', pathMatch: 'full', data: { languages: ["EN", "ES", "FR"] } },
     //Wild Card Route 404
     { path: '**', pathMatch: 'full', component: WrongRouteComponent, data: { languages: ["EN"] } },
];

@NgModule({
     imports: [RouterModule.forRoot(routes)],
     exports: [RouterModule]
})
export class AppRoutingModule {
     deepLink: string = `${environment.BASE_URL}`;
     constructor(private router: Router, 
          private sessionTimerService: SessionTimerService, 
          private route: ActivatedRoute, 
          private authService: AuthenticationService, private generalService: GeneralService) {
          
          this.router.events.subscribe((event : any) => {

               if (event instanceof NavigationEnd) {
                    const eventURl = event.url;
                    this.generalService.pageLogging(event.url, "", "", "", "Router").subscribe((v: any) => {})
                    if(event.url.includes('redirectUrl')){
                         this.routingHandler(event.url);
                    }else if(event.url.toLocaleLowerCase().includes('default.')){
                         this.router.navigateByUrl('/home')
                    }
                    const isRestricted = routes.find((r:any) => ("/" + r.path) === eventURl && r.path !== "termsandconditions");
                    //terms INI's the session after the user data is loaded.
                    if (isRestricted && isRestricted!.data && isRestricted!.data['restricted'] && isRestricted!.data['restricted'] === true) {
                         this.sessionTimerService.clear();
                         this.sessionTimerService.extendSession(); // Call your service method on route change
                    }
               }
          });
     }

     private getQueryParameters(url:string) {
          const regex = /[?&]([^=#]+)=([^&#]*)/g;
          const params : { [key: string]: string } = {};
          let match;
        
          while ((match = regex.exec(url)) !== null) {
            params[match[1]] = decodeURIComponent(match[2]);
          }
        
          return params;
        }
     
     routingHandler(redirectString: string) {
          window.onbeforeunload = null;
          const queryParams = this.getQueryParameters(redirectString);
          if (queryParams && queryParams['redirectUrl']) {
               const redirectUrl = queryParams['redirectUrl'];

               if (redirectUrl.startsWith('driver/10') && queryParams['token']) {
                    this.router.navigate(['driver', '10'], { queryParams: { token: queryParams['token'] } });   
               } else if (redirectUrl === 'driver/1/subscribe') {
                    this.router.navigate(['driver', '1/subscribe']);    
               } else if (redirectUrl === 'driver/subscribed') {
                    this.router.navigate(['driver', 'subscribed']);         
               } else if (redirectUrl === 'driver/11') {
                    this.router.navigate(['driver', '11']);
               } else if (redirectUrl.startsWith('driver/6') && queryParams['dupLic']) {
                    this.router.navigate(['driver', '6'], { queryParams: { dupLic: queryParams['dupLic'] } })
               } else if (redirectUrl === 'applicant') {
                    this.router.navigate(['driver', '1']);
               } else if (redirectUrl === 'reorder') {
                    this.router.navigate(['driver', '2']);
               } else if (redirectUrl === 'applicantDashboard' || redirectUrl === 'driverDashboard') {
                    this.router.navigateByUrl('/driverDashboard');
               } else if (redirectUrl === 'driverDashboard' || redirectUrl === 'driverDashboard') {
                    this.router.navigateByUrl('/driverDashboard');
               } else if (redirectUrl === 'monitoringSettings') {
                    this.router.navigateByUrl('/monitoring');
               } else if (redirectUrl === 'monitoring') {
                    this.router.navigateByUrl('/monitoring');
               } else if (redirectUrl === 'applicationException') {
                    this.router.navigateByUrl('/applicationException').catch((err: any) => { console.error(err) });
               } else if (redirectUrl === 'customerSupport') {
                    this.router.navigateByUrl('/customerSupport')
               } else if (redirectUrl === 'news') {
                    if (queryParams['previewItemId']) {
                         if (queryParams['previewParentItemId']) {
                              this.router.navigateByUrl(`/news?previewItemId=${queryParams['previewItemId']}&previewParentItemId=${queryParams['previewParentItemId']}`);  
                         } else {
                              this.router.navigateByUrl(`/news?previewItemId=${queryParams['previewItemId']}`);
                         }  
                    } else {     
                         this.router.navigateByUrl('/news');
                    }
               } else if (redirectUrl === 'FAQ') {
                    if (queryParams['previewItemId']) {
                         if (queryParams['previewParentItemId']) {
                              this.router.navigateByUrl(`/FAQ?previewItemId=${queryParams['previewItemId']}&previewParentItemId=${queryParams['previewParentItemId']}`);  
                         } else {
                              this.router.navigateByUrl(`/FAQ?previewItemId=${queryParams['previewItemId']}`);
                         }  
                    } else {     
                         this.router.navigateByUrl('/FAQ');
                    }
               } else if (redirectUrl === 'termsAndConditions' && queryParams['accountType']) {
                    this.router.navigateByUrl(`/eula?accountType=${queryParams['accountType']}`)
               } else if (redirectUrl === 'signup') {
                    this.router.navigateByUrl('/signup/welcome')
               }  else if (redirectUrl === 'signin') {
                    this.router.navigateByUrl(`/signin?message=${queryParams['message']}`);
               } else if (redirectUrl === 'invoice') {
                    this.router.navigateByUrl('/invoice');
               } else if (redirectUrl === 'probationOrderSuccess') {
                    this.router.navigateByUrl('/probationOrderSuccess');
               } else if (redirectUrl === 'requestRecords') {
                    this.router.navigateByUrl('/requestRecords');
               } else if (redirectUrl === 'accessDenied') {
                    this.router.navigateByUrl('/accessDenied');
               } else if (redirectUrl === 'auditDashboard') {
                    this.deepLink +=  redirectString;
                    this.authService.setDeepLink(this.deepLink);
                    this.router.navigateByUrl('/auditDashboard');
               } else if (redirectUrl === 'auditAcknowledgement') {
                    this.router.navigateByUrl('/auditAcknowledgement');
               } else if (redirectUrl === 'dashboard') {
                    this.router.navigate(['/dashboard']);
               } else if (redirectUrl === 'userAccountAdmin') {
                    this.router.navigateByUrl('/userAccountAdmin');
               } else if (redirectUrl === 'editAccountAdmin') {
                    this.router.navigateByUrl(`/editAccountAdmin?id=${queryParams['id']}`);  
               } else if (redirectUrl === 'byAuthCode') {
                    if (queryParams['authCode']) {
                         this.deepLink +=  redirectString;
                         this.authService.setDeepLink(this.deepLink);
                         this.router.navigateByUrl(`/byAuthCode/${queryParams['authCode']}`);
                    } else {
                         this.router.navigateByUrl('/customerSupportInfo');
                    }
               } else if (redirectUrl === 'payment') {
                    this.router.navigateByUrl('/payment');
               } else if (redirectUrl === 'veterans') {
                    this.router.navigateByUrl('/veterans');
               } else if (redirectUrl === 'women-drivers') {
                    this.router.navigateByUrl('/women-drivers');
               } else if (redirectUrl === 'wsToken') {
                    this.router.navigateByUrl('/wsToken');
               } else if (redirectUrl === 'drivers') {
                    this.router.navigateByUrl('/drivers');
               } else if (redirectUrl === 'pspStyles') {
                    this.router.navigateByUrl('/pspStyles');
               } else if (redirectUrl === 'wsToken') {
                    this.router.navigateByUrl('/wsToken');
               } else if (redirectUrl === 'wsAPI') {
                    this.router.navigateByUrl('/wsAPI');
               } else if (redirectUrl === 'MvrByState') {
                    this.router.navigateByUrl('/MvrByState');
               } else if (redirectUrl === 'billingReports') {
                    this.router.navigateByUrl('/billingReports');
               } else if (redirectUrl === 'notFound') {
                    this.router.navigateByUrl('/**');
               } else {
                    this.router.navigateByUrl('/customerSupportInfo').catch((err: any) => { console.error(err) });
               }
          }
     }
}
